import { cx } from '@chakra-ui/utils';
import type {
  PlaceholderProps as ReactSelectPlaceholderProps,
  OptionTypeBase,
} from 'react-select';

import { Box, type BoxProps } from '@frontend/components';

import { useSelectStyles } from '../SelectStylesContext';
import { BASE_CLASS_NAME } from '../const';

export type PlaceholderProps<
  OptionType extends OptionTypeBase,
  IsMulti extends boolean,
> = ReactSelectPlaceholderProps<OptionType, IsMulti> & {
  innerProps: BoxProps;
};

export const Placeholder = <
  OptionType extends OptionTypeBase,
  IsMulti extends boolean,
>({
  children,
  innerProps,
}: PlaceholderProps<OptionType, IsMulti>) => {
  const { placeholder: placeholderStyles } = useSelectStyles();

  return (
    <Box
      {...innerProps}
      className={cx(`${BASE_CLASS_NAME}__placeholder`, innerProps?.className)}
      __css={placeholderStyles}
    >
      {children}
    </Box>
  );
};
